module.exports = {"650203001":"天山路街道","650203002":"胜利路街道","650203003":"昆仑路街道","650203004":"银河路街道","650203006":"五五新镇街道","650203007":"迎宾街道","650203008":"古海街道","650203200":"小拐乡","650203506":"兵团一二九团分部","650203530":"兵团一三六团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650203.json
// module id = 3200
// module chunks = 0